import { config } from '../config';
import { AnalyticsClass } from '@frontend/analytics-wrapper';

export const Analytics = new AnalyticsClass('');
